import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    // These will eventually be fetched from an API
    //layoutConfig: {
    //    masterLayout: localStorage.getItem('masterLayout') || 'classic',
    //    dashboardLayout: localStorage.getItem('dashboardLayout') || 'classic',
    //    sidebarLayout: localStorage.getItem('sidebarLayout') || 'classic',
    //    packetBookingLayout: localStorage.getItem('packetBookingLayout') || 'classic',
    //    pickupEntryLayout: localStorage.getItem('pickupEntryLayout') || 'classic',
    //    paginationStyle: localStorage.getItem('paginationStyle') || 'classic',
    //    tableLayout: localStorage.getItem('tableLayout') || 'classic',
    //    tableFilter: localStorage.getItem('tableFilter') || 'classic',
    //    isAdvancedView: localStorage.getItem('isAdvancedView') === 'true',
    //    pageTransitions: localStorage.getItem('pageTransitions') === 'true',
    //    headerLayout: localStorage.getItem('headerLayout') || 'advanced',
    //    notificationLayout: localStorage.getItem('notificationLayout') || 'classic',
    //    tableDeleteStyle: localStorage.getItem('tableDeleteStyle') || 'classic',
    //    deleteConfirmStyle: localStorage.getItem('deleteConfirmStyle') || 'swal',
    //    //inputFieldStyle
    //    inputFieldStyle: localStorage.getItem('inputFieldStyle') || 'classic',
    //    branchMappingLayout: localStorage.getItem('branchMappingLayout') || 'classic',
    //},
    currentLanguage: localStorage.getItem('language') || 'English',
    translations: { langs: [], data: [] }, // Initially empty, will load from IndexedDB or API
};

const settingsSlice = createSlice({
    name: "settings",
    initialState,
    reducers: {
        //setLayoutConfig: (state, action) => {
        //    state.layoutConfig = {
        //        ...state.layoutConfig,
        //        ...action.payload
        //    };

        //    // Sync to local storage for now until API is ready
        //    Object.keys(action.payload).forEach(key => {
        //        localStorage.setItem(key, action.payload[key]);
        //    });

        //    // Dispatch a custom event for components outside React tree or for legacy compatibility
        //    window.dispatchEvent(new CustomEvent('layout-config-change', { detail: state.layoutConfig }));
        //},
        //setInitialLayoutConfig: (state, action) => {
        //    state.layoutConfig = action.payload;
        //},
        setCurrentLanguage: (state, action) => {
            state.currentLanguage = action.payload;
            localStorage.setItem('language', action.payload);
        },
        setTranslations: (state, action) => {
            state.translations = action.payload;
        }
    }
});

export const { setLayoutConfig, setInitialLayoutConfig, setCurrentLanguage, setTranslations } = settingsSlice.actions;
export default settingsSlice.reducer;
